export default __webpack_public_path__ + "static/media/gallitoDeLasRocas.3915452b.png";